/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Button, FloatingBox, Grid, Margin, Text } from '@zapier/design-system';

import Dismiss from 'app/developer-v3/components/Dismiss';
import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

type Props = {
  autoDismiss: boolean;
  isCode: boolean;
  onClickButton: () => void;
  onClickOutside: () => void;
};

function ToggleModal({
  autoDismiss,
  isCode,
  onClickButton,
  onClickOutside: close,
}: Props) {
  const onClick = () => {
    onClickButton();
    close();
  };

  const link = (
    <Link href={`${BASE_DOC_URL_VB}/build/code-mode`} target="_blank">
      Learn More
    </Link>
  );

  return (
    <FloatingBox
      maxWidth="350px"
      onClickOutside={autoDismiss && close}
      position="north"
    >
      <Margin margin="15px">
        <Grid alignItems="center" columns="auto 30px">
          <Text tag="h3" type="Body4">
            {isCode ? 'Use a simple form' : 'Write code for greater control'}
          </Text>
          <Dismiss ariaLabel="Close Help Box" onDismiss={close} />
        </Grid>
        {isCode ? (
          <Text color="GrayWarm7" margin="10px 0px 10px 0px" tag="p">
            Switch back to form mode for simple API calls without
            post-processing. Your code will be saved but not used, and new form
            data will not be added to code mode. {link}.
          </Text>
        ) : (
          <Text color="GrayWarm7" margin="10px 0px 10px 0px" tag="p">
            Switch to code mode to customize the API call and add
            post-processing in JavaScript. Zapier will convert your form entry
            to code the first time you switch to code mode. {link}.
          </Text>
        )}
        <Button
          aria-label={
            isCode
              ? 'Confirm Switch to Form Mode'
              : 'Confirm Switch to Code Mode'
          }
          isFullWidth={true}
          onClick={onClick}
        >
          {isCode ? 'Switch to Form Mode' : 'Switch to Code Mode'}
        </Button>
      </Margin>
    </FloatingBox>
  );
}

ToggleModal.defaultProps = {
  autoDismiss: true,
};

export default ToggleModal;
